import {
  checkValidationValue,
  getAvailabilityStatus,
  getAvailabilityStatusText,
  getLocalProperty,
  getLocationProperty,
  getProductProperty,
  getTwoProductProperty,
} from "./utils";
import { PriceModes } from "@components/molecules/PriceModeCard/types";
import moment from "moment";
import currency from "currency.js";
import { VDBIcons } from "@utils/VDBIcons";
import { getCommentData } from "@scenes/pdp/utils/utils";

export const getTotalProductDetailsArray = (
  t: any,
  itemDetail: any,
  userInfo: any,
  priceMode: any,
  dateFormat: any,
  userCurrency: any,
  isCustomApp: any,
  MoreNumber: any,
  showNumber: any,
  localSelectedLocation: any,
  otherSelectedLocation: any,
  supplierSpecificCommentInOrangeMode: boolean = false
) => [
  {
    id: 180,
    title: "",
    description: getProductProperty(itemDetail?.short_title, ""),
    hideDivider: true,
    isTitle: true,
    valueTextSize: "H1-B",
    icon: "upd-diamonds",
  },
  {
    id: 181,
    title: "Stock#",
    description: getProductProperty(
      (!isCustomApp && itemDetail?.bmh_request_type !== "retail_buy_request"
        ? "VDB-"
        : "") + itemDetail?.stock_num,
      ""
    ),
    icon: "upd-diamonds",
  },
  {
    id: 182,
    title: "Status",
    description: getProductProperty(
      getAvailabilityStatusText(userInfo, itemDetail?.available),
      ""
    ),
    icon:
      priceMode !== PriceModes.GREEN
        ? getAvailabilityStatus(itemDetail)
        : undefined,
  },
  {
    id: 183,
    title: "Last Refreshed",
    description: getProductProperty(
      moment(itemDetail?.last_updated_at).format(dateFormat),
      ""
    ),
    icon: "upd-diamonds",
  },
  {
    id: 184,
    title: "P/ct",
    description: getProductProperty(
      currency(itemDetail?.price_per_carat, {
        symbol: userCurrency,
        precision: 0,
      }).format(),
      ""
    ),
    icon: "upd-diamonds",
  },
  {
    id: 186,
    title: "Disc",
    description: getProductProperty(itemDetail?.discount_percent, "%"),
    icon: "upd-diamonds",
  },
  {
    id: 187,
    title: "Total Price",
    description: getProductProperty(
      currency(itemDetail?.total_sales_price, {
        symbol: userCurrency,
        precision: 2,
      }).format(),
      ""
    ),
    icon: "upd-diamonds",
  },
  {
    id: 189,
    title: "Lab",
    description: `${getProductProperty(itemDetail?.lab, "")}`,
    icon: "upd-diamonds",
  },
  {
    id: 326,
    title: "Cut",
    description: getProductProperty(itemDetail?.cut, ""),
    icon: "upd-labGrown",
  },
  {
    id: 327,
    title: "Polish",
    description: getProductProperty(itemDetail?.polish, ""),
    icon: "upd-labGrown",
  },
  {
    id: 328,
    title: "Sym",
    description: getProductProperty(itemDetail?.symmetry, ""),
    icon: "upd-labGrown",
  },
  {
    id: 329,
    title: "Fluor",
    description: getProductProperty(itemDetail?.fluor_intensity, ""),
    icon: "upd-labGrown",
  },
  {
    id: 310,
    title: "Depth",
    description: getProductProperty(itemDetail?.depth_percent, "%"),
    icon: "upd-labGrown",
  },
  {
    id: 311,
    title: "Table",
    description: getProductProperty(
      currency(itemDetail?.table_percent, {
        symbol: "",
        precision: 0,
      }).format(),
      "%"
    ),
    icon: "upd-labGrown",
  },
  {
    id: 232,
    title: "Girdle",
    description: getProductProperty(itemDetail?.girdle_condition, ""),
    icon: "upd-labGrown",
  },
  {
    id: 233,
    title: "Crown",
    description: getTwoProductProperty(
      itemDetail?.crown_height,
      "%",
      itemDetail?.crown_angle,
      "°"
    ),
    icon: "upd-labGrown",
  },
  {
    id: 234,
    title: "Pavillion",
    description: getTwoProductProperty(
      itemDetail?.pavilion_depth,
      "%",
      itemDetail?.pavilion_angle,
      "°"
    ),
    icon: "upd-labGrown",
  },
  {
    id: 235,
    title: "Culet",
    description: getProductProperty(itemDetail?.culet_size, ""),
    icon: "upd-labGrown",
  },
  {
    id: 236,
    title: "Meas",
    description: getProductProperty(itemDetail?.measurement, ""),
    icon: "upd-labGrown",
  },
  {
    id: 237,
    title: "Ratio",
    description: getProductProperty(itemDetail?.meas_ratio, ""),
    icon: "upd-labGrown",
  },
  {
    id: 238,
    title: "BGM",
    description: getProductProperty(itemDetail?.bgm, ""),
    icon: "upd-labGrown",
  },
  {
    id: 239,
    title: "Treat",
    description: getProductProperty(itemDetail?.treatment, ""),
    icon: "upd-labGrown",
  },
  {
    id: 439,
    title: "Comment",
    description: getCommentData(
      getProductProperty(itemDetail?.item_comment, ""),
      itemDetail,
      priceMode,
      supplierSpecificCommentInOrangeMode,
      t
    ),
    icon: "upd-labGrown",
  },
  {
    id: 430,
    title: "Location",
    description: getLocationProperty(
      localSelectedLocation,
      otherSelectedLocation,
      "location_name",
      "",
      true
    ),
    isLocation: true,
    icon: "upd-labGrown",
  },
  {
    id: 433,
    title: "Supplier",
    description: getProductProperty(itemDetail?.vendor_name, ""),
    icon: "upd-labGrown",
  },
  {
    id: 434,
    title: "City",
    description: getLocationProperty(
      localSelectedLocation,
      otherSelectedLocation,
      "city",
      "",
      true
    ),
    icon: "upd-labGrown",
  },
  {
    id: 435,
    title: "Country",
    description: getLocationProperty(
      localSelectedLocation,
      otherSelectedLocation,
      "country",
      "",
      true
    ),
    icon: "upd-labGrown",
  },
  {
    id: 343,
    title: "",
    description: t("findMatch.showPhoneNumber.text"),
    clickToShow: true,
    showNumber: MoreNumber,
    icon: "upd-labGrown",
  },
  {
    id: 346,
    title: "Contact",
    description: getLocationProperty(
      localSelectedLocation,
      otherSelectedLocation,
      "contact_person",
      "",
      true
    ),
    icon: "upd-labGrown",
    showNumber: checkValidationValue(
      itemDetail?.locations,
      "contact_person",
      showNumber
    ),
  },
  {
    id: 347,
    title: "Office",
    description: getLocationProperty(
      localSelectedLocation,
      otherSelectedLocation,
      "office_phone",
      "contact_phone_country_code",
      true
    ),
    color: "link-static",
    icon: "upd-labGrown",
    clickable: true,
    showNumber: checkValidationValue(
      itemDetail?.locations,
      "office_phone",
      showNumber
    ),
  },
  {
    id: 349,
    title: "Mobile",
    description: getLocationProperty(
      localSelectedLocation,
      otherSelectedLocation,
      "mobile_phone",
      "mobile_phone_country_code",
      true
    ),
    color: "link-static",
    icon: "upd-labGrown",
    clickable: true,
    showNumber: checkValidationValue(
      itemDetail?.locations,
      "mobile_phone",
      showNumber
    ),
  },
  {
    id: 351,
    title: "socialmedia",
    description: getLocationProperty(
      localSelectedLocation,
      otherSelectedLocation,
      "mobile_phone",
      "mobile_phone_country_code",
      true
    ),
    color: "link-static",
    icon: "upd-labGrown",
    clickable: true,
    showNumber: checkValidationValue(
      itemDetail?.locations,
      "mobile_phone",
      showNumber
    ),
    WhatsApp: checkValidationValue(
      itemDetail?.locations,
      "contact_whatsapp",
      showNumber
    ),
    WhatsAppCountry: checkValidationValue(
      itemDetail?.locations,
      "contact_whatsapp_country_code",
      showNumber
    ),
    FaceTime: checkValidationValue(
      itemDetail?.locations,
      "contact_iphone",
      showNumber
    ),
    FaceTimeCountry: checkValidationValue(
      itemDetail?.locations,
      "contact_iphone_country_code",
      showNumber
    ),
  },
  {
    id: 344,
    title: "Supplier's Comments",
    description: getProductProperty(itemDetail?.supplier_specific_comment, ""),
    icon: "upd-labGrown",
    showNumber: getLocalProperty(itemDetail, "supplier_specific_comment"),
  },
  // Add more items as needed
];

export const getTotalOtherDetailsArray = (
  otherDetail: any,
  currentIndex: any,
  userInfo: any,
  dateFormat: any,
  userCurrency: any,
  isCustomApp: any,
  showNumber: any,
  localSelectedLocation: any,
  otherSelectedLocation: any,
  priceMode: PriceModes,
  supplierSpecificCommentInOrangeMode: boolean = false,
  t: any
) => [
  {
    id: 0,
    title: "",
    description: getProductProperty(
      otherDetail?.[currentIndex]?.short_title,
      ""
    ),
    hideDivider: true,
    isTitle: true,
    valueTextSize: "H1-B",
    icon: VDBIcons.UPD_DIAMONDS,
  },
  {
    id: 1,
    title: "Stock#",
    description: getProductProperty(
      (!isCustomApp &&
      otherDetail?.[currentIndex]?.bmh_request_type !== "retail_buy_request"
        ? "VDB-"
        : "") + otherDetail?.[currentIndex]?.stock_num,
      ""
    ),
    icon: VDBIcons.UPD_DIAMONDS,
  },
  {
    id: 1,
    title: "Status",
    description: getProductProperty(
      getAvailabilityStatusText(
        userInfo,
        otherDetail?.[currentIndex]?.available
      ),
      ""
    ),
    icon: getAvailabilityStatus(otherDetail?.[currentIndex]),
  },
  {
    id: 1,
    title: "Last Refreshed",
    description: getProductProperty(
      moment(otherDetail?.[currentIndex]?.last_updated_at).format(dateFormat),
      ""
    ),
    icon: "upd-diamonds",
  },
  {
    id: 13,
    title: "P/ct",
    description: getProductProperty(
      currency(otherDetail?.[currentIndex]?.price_per_carat, {
        symbol: userCurrency,
        precision: 0,
      }).format(),
      ""
    ),
    icon: "upd-diamonds",
  },
  {
    id: 1,
    title: "Disc",
    description: getProductProperty(
      otherDetail?.[currentIndex]?.discount_percent,
      "%"
    ),
    icon: "upd-diamonds",
  },
  {
    id: 1,
    title: "Total Price",
    description: getProductProperty(
      currency(otherDetail?.[currentIndex]?.total_sales_price, {
        symbol: userCurrency,
        precision: 2,
      }).format(),
      ""
    ),
    icon: "upd-diamonds",
  },
  {
    id: 1,
    title: "Lab",
    description: `${getProductProperty(otherDetail?.[currentIndex]?.lab, "")}`,
    icon: "upd-diamonds",
  },
  {
    id: 6,
    title: "Cut",
    description: getProductProperty(otherDetail?.[currentIndex]?.cut, ""),
    icon: "upd-labGrown",
  },
  {
    id: 7,
    title: "Polish",
    description: getProductProperty(otherDetail?.[currentIndex]?.polish, ""),
    icon: "upd-labGrown",
  },
  {
    id: 8,
    title: "Sym",
    description: getProductProperty(otherDetail?.[currentIndex]?.symmetry, ""),
    icon: "upd-labGrown",
  },
  {
    id: 9,
    title: "Fluor",
    description: getProductProperty(
      otherDetail?.[currentIndex]?.fluor_intensity,
      ""
    ),
    icon: "upd-labGrown",
  },
  {
    id: 10,
    title: "Depth",
    description: getProductProperty(
      otherDetail?.[currentIndex]?.depth_percent,
      "%"
    ),
    icon: "upd-labGrown",
  },
  {
    id: 11,
    title: "Table",
    description: getProductProperty(
      currency(otherDetail?.[currentIndex]?.table_percent, {
        symbol: "",
        precision: 0,
      }).format(),
      "%"
    ),
    icon: "upd-labGrown",
  },
  {
    id: 12,
    title: "Girdle",
    description: getProductProperty(
      otherDetail?.[currentIndex]?.girdle_condition,
      ""
    ),
    icon: "upd-labGrown",
  },
  {
    id: 13,
    title: "Crown",
    description: getTwoProductProperty(
      otherDetail?.[currentIndex]?.crown_height,
      "%",
      otherDetail?.[currentIndex]?.crown_angle,
      "°"
    ),
    icon: "upd-labGrown",
  },
  {
    id: 14,
    title: "Pavillion",
    description: getTwoProductProperty(
      otherDetail?.[currentIndex]?.pavilion_depth,
      "%",
      otherDetail?.[currentIndex]?.pavilion_angle,
      "°"
    ),
    icon: "upd-labGrown",
  },
  {
    id: 15,
    title: "Culet",
    description: getProductProperty(
      otherDetail?.[currentIndex]?.culet_size,
      ""
    ),
    icon: "upd-labGrown",
  },
  {
    id: 16,
    title: "Meas",
    description: getProductProperty(
      otherDetail?.[currentIndex]?.measurement,
      ""
    ),
    icon: "upd-labGrown",
  },
  {
    id: 17,
    title: "Ratio",
    description: getProductProperty(
      otherDetail?.[currentIndex]?.meas_ratio,
      ""
    ),
    icon: "upd-labGrown",
  },
  {
    id: 18,
    title: "BGM",
    description: getProductProperty(otherDetail?.[currentIndex]?.bgm, ""),
    icon: "upd-labGrown",
  },
  {
    id: 19,
    title: "Treat",
    description: getProductProperty(otherDetail?.[currentIndex]?.treatment, ""),
    icon: "upd-labGrown",
  },
  {
    id: 19,
    title: "Comment",
    description: getCommentData(
      getProductProperty(otherDetail?.[currentIndex]?.item_comment, ""),
      otherDetail?.[currentIndex],
      priceMode,
      supplierSpecificCommentInOrangeMode,
      t
    ),
    icon: "upd-labGrown",
  },
  {
    id: 20,
    title: "Location",
    description: getLocationProperty(
      localSelectedLocation,
      otherSelectedLocation,
      "location_name",
      "",
      false
    ),
    icon: "upd-labGrown",
    isLocation: true,
  },
  {
    id: 23,
    title: "Supplier",
    description: getProductProperty(
      otherDetail?.[currentIndex]?.vendor_name,
      ""
    ),
    icon: "upd-labGrown",
  },
  {
    id: 24,
    title: "City",
    description: getLocationProperty(
      localSelectedLocation,
      otherSelectedLocation,
      "city",
      "",
      false
    ),
    icon: "upd-labGrown",
  },
  {
    id: 25,
    title: "Country",
    description: getLocationProperty(
      localSelectedLocation,
      otherSelectedLocation,
      "country",
      "",
      false
    ),
    icon: "upd-labGrown",
  },
  {
    id: 31,
    title: "",
    description: "Click to Show Phone Numbers",
    clickToShow: true,
    icon: "upd-labGrown",
    showNumber: showNumber,
  },
  {
    id: 71,
    title: "Contact",
    description: getLocationProperty(
      localSelectedLocation,
      otherSelectedLocation,
      "contact_person",
      ""
    ),
    icon: "upd-labGrown",
    showNumber: checkValidationValue(
      otherDetail?.[currentIndex]?.locations,
      "contact_person",
      showNumber
    ),
  },
  {
    id: 81,
    title: "Office",
    description: getLocationProperty(
      localSelectedLocation,
      otherSelectedLocation,
      "office_phone",
      "contact_phone_country_code"
    ),
    color: "link-static",
    icon: "upd-labGrown",
    clickable: true,
    showNumber: checkValidationValue(
      otherDetail?.[currentIndex]?.locations,
      "office_phone",
      showNumber
    ),
  },
  {
    id: 93,
    title: "Mobile",
    description: getLocationProperty(
      localSelectedLocation,
      otherSelectedLocation,
      "mobile_phone",
      "mobile_phone_country_code"
    ),
    color: "link-static",
    icon: "upd-labGrown",
    clickable: true,
    showNumber: checkValidationValue(
      otherDetail?.[currentIndex]?.locations,
      "mobile_phone",
      showNumber
    ),
  },
  {
    id: 95,
    title: "socialmedia",
    description: getLocationProperty(
      localSelectedLocation,
      otherSelectedLocation,
      "mobile_phone",
      "mobile_phone_country_code"
    ),
    color: "link-static",
    icon: "upd-labGrown",
    clickable: true,
    showNumber: checkValidationValue(
      otherDetail?.[currentIndex]?.locations,
      "mobile_phone",
      showNumber
    ),
    WhatsApp: checkValidationValue(
      otherDetail?.[currentIndex]?.locations,
      "contact_whatsapp",
      showNumber
    ),
    WhatsAppCountry: checkValidationValue(
      otherDetail?.[currentIndex]?.locations,
      "contact_whatsapp_country_code",
      showNumber
    ),
    FaceTime: checkValidationValue(
      otherDetail?.[currentIndex]?.locations,
      "contact_iphone",
      showNumber
    ),
    FaceTimeCountry: checkValidationValue(
      otherDetail?.[currentIndex]?.locations,
      "contact_iphone_country_code",
      showNumber
    ),
  },
  {
    id: 24,
    title: "Supplier's Comments",
    description: getProductProperty(
      otherDetail?.[currentIndex]?.supplier_specific_comment,
      ""
    ),
    icon: "upd-labGrown",
    showNumber: getLocalProperty(
      otherDetail?.[currentIndex],
      "supplier_specific_comment"
    ),
  },
  // Add more items as needed
];
